import { createSlice } from "@reduxjs/toolkit";
import { contactUsAPI } from "./ContactUsActions";

const contactUs = createSlice({
    name: "contactUs",
    initialState: {
        isContactUsDataLoading: false,
        contactUsData: {},
        error: null,
    },
    reducers: {
        addContactUsData: (state, action) => {
            state.contactUsData = action.payload
        }
    },
      extraReducers: (builder) => {
            builder
                .addCase(contactUsAPI.pending, (state) => {
                    state.isContactUsDataLoading = true;
                    state.error = null;
                })
                .addCase(contactUsAPI.fulfilled, (state, action) => {
                    state.isContactUsDataLoading = false;
                    state.contactUsData = action.payload;
                })
                .addCase(contactUsAPI.rejected, (state, action) => {
                    state.isContactUsDataLoading = false;
                    state.error = action.error.message;
                });
        },
});


export const { addContactUsData } = contactUs.actions;
export const contactUsReducer = contactUs.reducer;